export const SOURCE_FORM = "configOpportunitySource";